import { useMemo } from 'react';

type Props = { value: string; onChange: (iso: string) => void }; // value is YYYY-MM-DD or ''

const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export default function DobPicker({ value, onChange }: Props) {
  const [y, m, d] = useMemo(() => {
    if (!value) return ['', '', ''];
    const [yy, mm, dd] = value.split('-');
    return [yy, mm, dd];
  }, [value]);

  const thisYear = new Date().getFullYear();
  const years: string[] = [];
  for (let yr = thisYear - 18; yr >= thisYear - 100; yr--) years.push(String(yr));

  function set(next: { d?: string; m?: string; y?: string }) {
    const dd = next.d ?? d, mm = next.m ?? m, yy = next.y ?? y;
    if (!dd || !mm || !yy) { onChange(''); return; }
    // clamp day for that month/year
    const maxDay = new Date(Number(yy), Number(mm), 0).getDate();
    const cdd = String(Math.min(Number(dd), maxDay)).padStart(2, '0');
    onChange(`${yy}-${mm}-${cdd}`);
  }

  const days: string[] = [];
  for (let i = 1; i <= 31; i++) days.push(String(i).padStart(2, '0'));

  return (
    <div className="grid grid-cols-3 gap-2">
      <select className="input" value={d} onChange={(e) => set({ d: e.target.value })}>
        <option value="">DD</option>
        {days.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
      <select className="input" value={m} onChange={(e) => set({ m: e.target.value })}>
        <option value="">Month</option>
        {MONTHS.map((nm, i) => <option key={nm} value={String(i+1).padStart(2, '0')}>{nm}</option>)}
      </select>
      <select className="input" value={y} onChange={(e) => set({ y: e.target.value })}>
        <option value="">YYYY</option>
        {years.map((x) => <option key={x} value={x}>{x}</option>)}
      </select>
    </div>
  );
}
